import useSWR from 'swr';

import { IDetailResponse, IPaginatedResponse, ISimpleListResponse } from 'utils/types';

import { buildQuery, fetcher } from './utils';

export interface IBrand {
  id: number;
  name: string;
}

export const useSimpleBrandList = (params?: object) => {
  const { data, isLoading, mutate } = useSWR<ISimpleListResponse<IBrand>>(
    `/v4/dash/simple/brands?${buildQuery(params)}`,
    fetcher
  );

  return { data: data?.data, isLoading, mutate };
};

export const useBrandList = (params: Record<string, any> = {}) => {
  const { data, isLoading, isValidating, error, mutate } = useSWR<IPaginatedResponse<IBrand>>(
    { url: '/v4/dash/brands', params },
    fetcher
  );

  return { data: data?.data, meta: data?.meta, isLoading, isValidating, error, mutate };
};

export const useBrand = (id?: number | string | null) => {
  const { data, isLoading, isValidating, error, mutate } = useSWR<IDetailResponse<IBrand>>(
    id ? `/v4/dash/brands/${id}` : null,
    fetcher
  );

  return { data: data?.data, isLoading, isValidating, error, mutate };
};
